/* eslint-disable no-new */
// import Carousel from 'bootstrap/js/dist/carousel';
import { Collapse, Dropdown, Offcanvas, Toast, Tooltip } from 'bootstrap';

function initializeDropdowns() {
  const dropdownList = Array.from(document.querySelectorAll('.dropdown'));

  dropdownList.forEach(dropdownEl => {
    new Dropdown(dropdownEl);
  });
}

function initializeCollapse() {
  const collapseElementList = document.querySelectorAll('.collapse');

  [...collapseElementList].map(
    collapseEl => new Collapse(collapseEl, { toggle: false })
  );
}

function initializeToast() {
  const toastElList = document.querySelectorAll('.toast');
  const toasts = [...toastElList].map(toastEl => new Toast(toastEl));

  toasts.map(t => !t.isShown() && t.show());

  return toasts;
}

function initializeOffcanvas() {
  const offcanvasElementList = document.querySelectorAll('.offcanvas');

  [...offcanvasElementList].map(offcanvasEl => new Offcanvas(offcanvasEl));
}

// Uncomment this if you are using carousels
// function initializeCarousels() {
//   const carouselList = Array.from(document.querySelectorAll('.carousel'));

//   carouselList.forEach(carouselEl => {
//     new Carousel(carouselEl);
//   });
// }

// Uncomment this if you are using tabs
// function initializeTabs() {
//   const tabList = Array.from(
//     document.querySelectorAll('[data-bs-toggle="tab"]')
//   );

//   tabList.forEach(tabEl => {
//     new Tab(tabEl);
//   });
// }

// Uncomment this if you are using tooltips
function initializeTooltips() {
  const tooltipTriggerList = Array.from(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );

  tooltipTriggerList.forEach(tooltipTriggerEl => {
    new Tooltip(tooltipTriggerEl);
  });
}

['DOMContentLoaded', 'turbo:render', 'turbo:frame-render'].forEach(evt =>
  document.addEventListener(evt, () => {
    initializeDropdowns();
    initializeToast();
    initializeOffcanvas();
    initializeCollapse();
    // initializeCarousels();
    // initializeTabs();
    initializeTooltips();
  })
);
